<!-- 球队管理 -->
<template>
    <div>
        <event-head></event-head>
        <div class="mt-3">
            <el-table :data="personinfo" style="width: 100%" :header-cell-style="{
                color: '#fff',
                fontSize: '14px',
                height: '40px',
                width: '100%',
            }">
                <el-table-column prop="name" label="收款人" align="center" width=""></el-table-column>
                <el-table-column prop="account" label="收款账号" align="center"></el-table-column>
                <el-table-column prop="settlement" label="结算方式" align="center"></el-table-column>
                <el-table-column prop="bank" label="开户行" align="center"></el-table-column>
                <el-table-column prop="mobile" label="联系电话" align="center"></el-table-column>
                <el-table-column prop="time" label="加盟时间:" align="center"></el-table-column>
                <el-table-column prop="type" label="加盟方式" align="center"></el-table-column>
                <!-- <el-table-column label="技术微信" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.wechat" style="width: 100px;height:100px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="企业微信" align="center">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.companywechat" style="width: 100px;height:100px"
                            @click="editLogo(scope.row)"></el-image>
                    </template>
                </el-table-column> -->
            </el-table>
            <!-- <el-pagination layout="total, prev, pager, next" :current-page="pageInfo.page"
            :page-size="pageInfo.pageSize" :total="pageInfo.count"
            @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination> -->
        </div>
    </div>
</template>

<script>
import EventHead from '@/common/components/eventHead/EventHead';
export default {
    components: {
        EventHead
    },
    data() {
        return {
            pageInfo: {
                page: 1,
                pageSize: 10,
                count: 0,
            },
            personinfo:[{
                name:'詹大炮',
                account:'6989396797090770',
                mobile:'13567896543',
                settlement:'银行对私转账',
                bank:'中国工商银行',
                time:'2025/07/01',
                type:'2',
                wechat:'https://x-ai.oss-cn-hangzhou.aliyuncs.com/2025.4.24/2.jpg',
                companywechat:'https://x-ai.oss-cn-hangzhou.aliyuncs.com/2025.4.24/1.jpg'
            }]

        };
    },
    mounted() {

    },
    methods: {


        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
        },
        handleCurrentChange(val) {
            this.pageInfo.page = val;
        },

    },
};
</script>

<style lang="scss" scoped>
.cardinal {
    margin-top: 30px;
}

.addMatch {
    margin-left: 30px;
    font-size: 16px;
    color: #000;

}

/deep/.el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: transparent;
    opacity: 1;
    border: none;
    border-bottom: 1px solid #9b9b9b;
    color: #fff;
    border-radius: 0;
}

.bottom_btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 10px;

    .addVenue {
        color: #fff;
    }
}
</style>